import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const { actions, reducer } = createSlice({

    name: 'version',

    initialState: 'initial',

    reducers: {
        overwrite: (state, action: PayloadAction<string>) => {
            return action.payload;
        }
    }
});